import moment from "moment";
import { defaultData as ArgentinaExportData } from "../default-values/argentina-export";
import { defaultData as ArgentinaImportData } from "../default-values/argentina-import";
import { defaultData as BrazilExportData } from "../default-values/brazil-export-mirror";
import { defaultData as BrazilImportData } from "../default-values/brazil-import-mirror";
import { defaultData as ChileExportData } from "../default-values/chile-export";
import { defaultData as ChileImportData } from "../default-values/chile-import";
import { defaultData as ColombiaExportData } from "../default-values/colombia-export";
import { defaultData as ColombiaImportData } from "../default-values/colombia-import";
import { defaultData as EcuadorExportData } from "../default-values/ecuador-export";
import { defaultData as EcuadorImportData } from "../default-values/ecuador-import";
import { defaultData as IndiaExportData } from "../default-values/india-export";
import { defaultData as IndiaImportData } from "../default-values/india-import";
import { defaultData as IndiaExportMirrorData } from "../default-values/india-export-mirror";
import { defaultData as IndiaImportMirrorData } from "../default-values/india-import-mirror";
import { defaultData as IndonesiaExportData } from "../default-values/indonesia-export-mirror";
import { defaultData as IndonesiaImportData } from "../default-values/indonesia-import-mirror";
import { defaultData as IndonesiaExportNmData } from "../default-values/indonesia-export-nm";
import { defaultData as IndonesiaImportNmData } from "../default-values/indonesia-import-nm";
import { defaultData as MexicoExportData } from "../default-values/mexico-export";
import { defaultData as MexicoImportData } from "../default-values/mexico-import";
import { defaultData as MultiCountryData } from "../default-values/multi-countries";
import { defaultData as PanamaExportData } from "../default-values/panama-export";
import { defaultData as PanamaImportData } from "../default-values/panama-import";
import { defaultData as PeruExportData } from "../default-values/peru-export";
import { defaultData as PeruImportData } from "../default-values/peru-import";
import { defaultData as PhilippinesExportData } from "../default-values/philippines-export";
import { defaultData as PhilippinesImportData } from "../default-values/philippines-import";
import { defaultData as UkExportData } from "../default-values/uk-export";
import { defaultData as UKImportData } from "../default-values/uk-import";
import { defaultData as UruguayExportData } from "../default-values/uruguay-export";
import { defaultData as UruguayImportData } from "../default-values/uruguay-import";
import { defaultData as UsExportData } from "../default-values/us-export";
import { defaultData as UsImportData } from "../default-values/us-import";
import { defaultData as VietnamExportData } from "../default-values/vietnam-export";
import { defaultData as VietnamImportData } from "../default-values/vietnam-import";
import { defaultData as RussiaImportData } from "../default-values/russia-import-mirror";
import { defaultData as RussiaExportData } from "../default-values/russia-export-mirror";
import { defaultData as RussiaImportNmData } from "../default-values/russia-import-nm";
import { defaultData as RussiaExportNmData } from "../default-values/russia-export-nm";
import { defaultData as ChinaImportData } from "../default-values/china-import-mirror";
import { defaultData as ChinaExportData } from "../default-values/china-export-mirror";
import { defaultData as SingaporeImportData } from "../default-values/singapore-import-mirror";
import { defaultData as SingaporeExportData } from "../default-values/singapore-export-mirror";
import { defaultData as UAEImportData } from "../default-values/uae-import-mirror";
import { defaultData as UAEExportData } from "../default-values/uae-export-mirror";
import { defaultData as MalaysiaImportData } from "../default-values/malaysia-import-mirror";
import { defaultData as MalaysiaExportData } from "../default-values/malaysia-export-mirror";
import { defaultData as ThailandImportData } from "../default-values/thailand-import-mirror";
import { defaultData as ThailandExportData } from "../default-values/thailand-export-mirror";
import { defaultData as TurkeyImportMirrorData } from "../default-values/turkey-import-mirror";
import { defaultData as TurkeyExportMirrorData } from "../default-values/turkey-export-mirror";
import { defaultData as AustraliaImportMirrorData } from "../default-values/australia-import-mirror";
import { defaultData as AustraliaExportMirrorData } from "../default-values/australia-export-mirror";
import { defaultData as MiddleEastImportMirrorData } from "../default-values/middle-east-import";
import { defaultData as MiddleEastExportMirrorData } from "../default-values/middle-east-export";
import { defaultData as EuropeImportMirrorData } from "../default-values/europe-import";
import { defaultData as EuropeExportMirrorData } from "../default-values/europe-export";
import { defaultData as TaiwanImportMirrorData } from "../default-values/taiwan-import-mirror";
import { defaultData as TaiwanExportMirrorData } from "../default-values/taiwan-export-mirror";
import { defaultData as SaudiArabiaImportMirrorData } from "../default-values/saudi-arabia-import-mirror";
import { defaultData as SaudiArabiaExportMirrorData } from "../default-values/saudi-arabia-export-mirror";
import { defaultData as CanadaImportMirrorData } from "../default-values/canada-import-mirror";
import { defaultData as CanadaExportMirrorData } from "../default-values/canada-export-mirror";
import { defaultData as GermanyImportMirrorData } from "../default-values/germany-import-mirror";
import { defaultData as GermanyExportMirrorData } from "../default-values/germany-export-mirror";
import { defaultData as HongKongImportMirrorData } from "../default-values/hong-kong-import-mirror";
import { defaultData as HongKongExportMirrorData } from "../default-values/hong-kong-export-mirror";
import { defaultData as JapanImportMirrorData } from "../default-values/japan-import-mirror";
import { defaultData as JapanExportMirrorData } from "../default-values/japan-export-mirror";
import { defaultData as SouthKoreaImportMirrorData } from "../default-values/south-korea-import-mirror";
import { defaultData as SouthKoreaExportMirrorData } from "../default-values/south-korea-export-mirror";
import { defaultData as USImportSearchMirrorData } from "../default-values/us-import-mirror";
import { defaultData as USExportSearchMirrorData } from "../default-values/us-export-mirror";
import { defaultData as MexicoImportSearchMaritimeData } from "../default-values/mexico-import-maritime";
import { defaultData as MexicoExportSearchMaritimeData } from "../default-values/mexico-export-maritime";
import { defaultData as GlobalImportData } from "../default-values/global-plan";
import { getApiUrl } from "../../../utils/baseUrl";
import { globalCountryDetailsDictionary } from "@core/global/global-country-details";
import { defaultData as BangladeshExportData } from "../default-values/bangladesh-export";
import { defaultData as BangladeshImportData } from "../default-values/bangladesh-import";
import { defaultData as GhanaImportData } from "../default-values/ghana-import";
import { defaultData as NamibiaImportData } from "../default-values/namibia-imports";
import { defaultData as NamibiaExportData } from "../default-values/namibia-exports";
import { defaultData as RwandaImportData } from "../default-values/rwanda-import";
import { defaultData as LesothoExportData } from "../default-values/lesotho-export";
import { defaultData as LesothoImportData } from "../default-values/lesotho-imports";
import { defaultData as KazakhstanImportData } from "../default-values/kazakhstan-import";
import { defaultData as KazakhstanExportData } from "../default-values/kazakhstan-export";
import { defaultData as NigeriaImportData } from "../default-values/nigeria-import";
import { defaultData as PakistanImportData } from "../default-values/pakistan-import";
import { defaultData as PakistanExportData } from "../default-values/pakistan-export";
import { defaultData as CameroonImportData } from "../default-values/cameroon-import";
import { defaultData as GhanaExportData } from "../default-values/ghana-export";
import { defaultData as BotswanaImportData } from "../default-values/botswana-import";
import { defaultData as BotswanaExportData } from "../default-values/botswana-export";
import { defaultData as IvoryCoastImportData } from "../default-values/ivory-coast-import";
import { defaultData as IvoryCoastExportData } from "../default-values/ivory-coast-export";
import { defaultData as NigeriaExportData } from "../default-values/nigeria-export";
import { defaultData as UzbekistanExportData } from "../default-values/uzbekistan-export";
import { defaultData as UzbekistanImportData } from "../default-values/uzbekistan-imports";
import { defaultData as SriLankaImportData } from "../default-values/srilanka-import";
import { defaultData as SriLankaExportData } from "../default-values/srilanka-export";
import { defaultData as ParaguayImportData } from "../default-values/paraguay-import";
import { defaultData as ParaguayExportData } from "../default-values/paraguay-export";
import { defaultData as CostaRicaImportData } from "../default-values/costa-rica-import";
import { defaultData as CostaRicaExportData } from "../default-values/costa-rica-export";
import { defaultData as EthiopiaImportData } from "../default-values/ethiopia-import";
import { defaultData as EthiopiaExportData } from "../default-values/ethiopia-export";
import { defaultData as UgandaImportData } from "../default-values/uganda-import";
import { defaultData as UgandaExportData } from "../default-values/uganda-export";
import { globalGetApiUrl } from "@utils/globalBaseUrl";

export const tempReturnObject = {
  Today: [moment.utc(new Date()).toDate(), moment.utc(new Date()).toDate()],
  Yesterday: [moment.utc(new Date()).subtract("1", "days").toDate(), moment.utc(new Date()).subtract("1", "days").toDate()],
  "Last 3 Days": [moment.utc(new Date()).subtract("3", "days").toDate(), moment.utc(new Date()).toDate()],
  "Last 7 Days": [moment.utc(new Date()).subtract("7", "days").toDate(), moment.utc(new Date()).toDate()],
  "Last 1 Month": [moment.utc(new Date()).subtract("1", "month").toDate(), moment.utc(new Date()).toDate()],
  "All Data": [moment.utc(new Date("1-1-2020")).toDate(), moment.utc(new Date()).toDate()],
};
export const redirectionUrls = {
  us_imports: "search-shipments",
  us_exports: "us-exports-search",
  mx_imports: "mexico-search-import",
  mx_exports: "mexico-search-export",
  br_imports: "brazil-search-import-mirror",
  br_exports: "brazil-search-export-mirror",
  ar_exports: "argentina-search-export",
  uy_exports: "uruguay-search-export",
  uy_imports: "uruguay-search-import",
  ec_imports: "ecuador-search-import",
  ec_exports: "ecuador-search-export",
  co_imports: "colombia-search-import",
  co_exports: "colombia-search-export",
  ar_imports: "argentina-search-import",
  pe_imports: "peru-search-import",
  pe_exports: "peru-search-export",
  pr_exports: "peru-search-export",
  pr_imports: "peru-search-import",
  uk_exports: "uk-search-export",
  uk_imports: "uk-search-import",
  gb_exports: "uk-search-export",
  gb_imports: "uk-search-import",
  pa_exports: "panama-search-export",
  pa_imports: "panama-search-import",
  ch_exports: "chile-search-export",
  ch_imports: "chile-search-import",
  cl_exports: "chile-search-export",
  cl_imports: "chile-search-import",
  id_exports: "indonesia-search-export-mirror",
  id_imports: "indonesia-search-import-mirror",
  idnm_exports: "indonesia-search-export-nm",
  idnm_imports: "indonesia-search-import-nm",
  ph_exports: "philippines-search-export",
  ph_imports: "philippines-search-import",
  vn_exports: "vietnam-search-export",
  vn_imports: "vietnam-search-import",
  inmr3_exports: "india-search-export",
  inmr3_imports: "india-search-import",
  inmr_exports: "india-search-export-mirror",
  inmr_imports: "india-search-import-mirror",
  world_imports: "all-country-shipments",
  ru_imports: "russia-search-import-mirror",
  ru_exports: "russia-search-export-mirror",
  runm_imports: "russia-search-import",
  runm_exports: "russia-search-export",
  cn_imports: "china-search-import-mirror",
  cn_exports: "china-search-export-mirror",
  sg_imports: "singapore-search-import-mirror",
  sg_exports: "singapore-search-export-mirror",
  my_imports: "malaysia-search-import-mirror",
  my_exports: "malaysia-search-export-mirror",
  th_imports: "thailand-search-import-mirror",
  th_exports: "thailand-search-export-mirror",
  tr_imports: "turkey-search-import-mirror",
  tr_exports: "turkey-search-export-mirror",
  ae_imports: "uae-search-import-mirror",
  ae_exports: "uae-search-export-mirror",
  au_imports: "australia-search-import-mirror",
  au_exports: "australia-search-export-mirror",
  middleeast_imports: "middle-east-search-import-mirror",
  middleeast_exports: "middle-east-search-export-mirror",
  eu_imports: "europe-search-import-mirror",
  eu_exports: "europe-search-export-mirror",
  tw_imports: "taiwan-search-import-mirror",
  tw_exports: "taiwan-search-export-mirror",
  sa_imports: "saudi-arabia-search-import-mirror",
  sa_exports: "saudi-arabia-search-export-mirror",
  ca_imports: "canada-search-import-mirror",
  ca_exports: "canada-search-export-mirror",
  de_imports: "germany-search-import-mirror",
  de_exports: "germany-search-export-mirror",
  hk_imports: "hong-kong-search-import-mirror",
  hk_exports: "hong-kong-search-export-mirror",
  jp_imports: "japan-search-import-mirror",
  jp_exports: "japan-search-export-mirror",
  kr_imports: "south-korea-search-import-mirror",
  kr_exports: "south-korea-search-export-mirror",
  usm_imports: "us-search-import-mirror",
  usm_exports: "us-search-export-mirror",
  mxm_imports: "mx-search-import-maritime",
  mxm_exports: "mx-search-export-maritime",
  global_imports: "global-search",
  mc_imports: "all-country-shipments",
  bw_imports: globalCountryDetailsDictionary.bw_import.countryPathName,
  bw_exports: globalCountryDetailsDictionary.bw_export.countryPathName,
  gh_imports: globalCountryDetailsDictionary.gh_import.countryPathName,
  gh_exports: globalCountryDetailsDictionary.gh_export.countryPathName,
  ls_imports: globalCountryDetailsDictionary.ls_import.countryPathName,
  ls_exports: globalCountryDetailsDictionary.ls_export.countryPathName,
  pk_imports: globalCountryDetailsDictionary.pk_import.countryPathName,
  pk_exports: globalCountryDetailsDictionary.pk_export.countryPathName,
  ci_imports: globalCountryDetailsDictionary.ci_import.countryPathName,
  ci_exports: globalCountryDetailsDictionary.ci_export.countryPathName,
  rw_imports: globalCountryDetailsDictionary.rw_import.countryPathName,
  na_imports: globalCountryDetailsDictionary.na_import.countryPathName,
  na_exports: globalCountryDetailsDictionary.na_export.countryPathName,
  cm_imports: globalCountryDetailsDictionary.cm_import.countryPathName,
  bd_imports: globalCountryDetailsDictionary.bd_import.countryPathName,
  bd_exports: globalCountryDetailsDictionary.bd_export.countryPathName,
  ng_imports: globalCountryDetailsDictionary.ng_import.countryPathName,
  ng_exports: globalCountryDetailsDictionary.ng_export.countryPathName,
  kz_imports: globalCountryDetailsDictionary.kz_import.countryPathName,
  kz_exports: globalCountryDetailsDictionary.kz_export.countryPathName,
  uz_imports: globalCountryDetailsDictionary.uz_import.countryPathName,
  uz_exports: globalCountryDetailsDictionary.uz_export.countryPathName,
  lk_imports: globalCountryDetailsDictionary.lk_import.countryPathName,
  lk_exports: globalCountryDetailsDictionary.lk_export.countryPathName,
  py_imports: globalCountryDetailsDictionary.py_import.countryPathName,
  py_exports: globalCountryDetailsDictionary.py_export.countryPathName,
  cr_imports: globalCountryDetailsDictionary.cr_import.countryPathName,
  cr_exports: globalCountryDetailsDictionary.cr_export.countryPathName,
  et_imports: globalCountryDetailsDictionary.et_import.countryPathName,
  et_exports: globalCountryDetailsDictionary.et_export.countryPathName,
  ug_imports: globalCountryDetailsDictionary.ug_import.countryPathName,
  ug_exports: globalCountryDetailsDictionary.ug_export.countryPathName,
};
export const filterDictonary = {
  mx_imports: [...MexicoImportData.normalfilterList],
  mx_exports: [...MexicoExportData.normalfilterList],
  br_exports: [...BrazilExportData.normalfilterList],
  ar_exports: [...ArgentinaExportData.normalfilterList],
  br_imports: [...BrazilImportData.normalfilterList],
  uy_exports: [...UruguayExportData.normalfilterList],
  uy_imports: [...UruguayImportData.normalfilterList],
  ec_imports: [...EcuadorImportData.normalfilterList],
  ec_exports: [...EcuadorExportData.normalfilterList],
  co_imports: [...ColombiaImportData.normalfilterList],
  co_exports: [...ColombiaExportData.normalfilterList],
  pr_exports: [...PeruExportData.normalfilterList],
  pr_imports: [...PeruImportData.normalfilterList],
  uk_exports: [...UkExportData.normalfilterList],
  uk_imports: [...UKImportData.normalfilterList],
  pa_exports: [...PanamaExportData.normalfilterList],
  pa_imports: [...PanamaImportData.normalfilterList],
  ar_imports: [...ArgentinaImportData.normalfilterList],
  cl_exports: [...ChileExportData.normalfilterList],
  cl_imports: [...ChileImportData.normalfilterList],
  us_exports: [...UsExportData.normalfilterList],
  us_imports: [...UsImportData.normalfilterList],
  id_exports: [...IndonesiaExportData.normalfilterList],
  id_imports: [...IndonesiaImportData.normalfilterList],
  idnm_exports: [...IndonesiaExportNmData.normalfilterList],
  idnm_imports: [...IndonesiaImportNmData.normalfilterList],
  ph_exports: [...PhilippinesExportData.normalfilterList],
  ph_imports: [...PhilippinesImportData.normalfilterList],
  vn_exports: [...VietnamExportData.normalfilterList],
  vn_imports: [...VietnamImportData.normalfilterList],
  inmr3_exports: [...IndiaExportData.normalfilterList],
  inmr3_imports: [...IndiaImportData.normalfilterList],
  inmr_exports: [...IndiaExportMirrorData.normalfilterList],
  inmr_imports: [...IndiaImportMirrorData.normalfilterList],
  world_imports: [...MultiCountryData.normalfilterList],
  ru_imports: [...RussiaImportData.normalfilterList],
  ru_exports: [...RussiaExportData.normalfilterList],
  runm_imports: [...RussiaImportNmData.normalfilterList],
  runm_exports: [...RussiaExportNmData.normalfilterList],
  cn_imports: [...ChinaImportData.normalfilterList],
  cn_exports: [...ChinaExportData.normalfilterList],
  sg_imports: [...SingaporeImportData.normalfilterList],
  sg_exports: [...SingaporeExportData.normalfilterList],
  my_imports: [...MalaysiaImportData.normalfilterList],
  my_exports: [...MalaysiaExportData.normalfilterList],
  th_imports: [...ThailandImportData.normalfilterList],
  th_exports: [...ThailandExportData.normalfilterList],
  tr_imports: [...TurkeyImportMirrorData.normalfilterList],
  tr_exports: [...TurkeyExportMirrorData.normalfilterList],
  ae_imports: [...UAEImportData.normalfilterList],
  ae_exports: [...UAEExportData.normalfilterList],
  au_imports: [...AustraliaImportMirrorData.normalfilterList],
  au_exports: [...AustraliaExportMirrorData.normalfilterList],
  middleeast_imports: [...MiddleEastImportMirrorData.normalfilterList],
  middleeast_exports: [...MiddleEastExportMirrorData.normalfilterList],
  europe_imports: [...EuropeImportMirrorData.normalfilterList],
  europe_exports: [...EuropeExportMirrorData.normalfilterList],
  tw_imports: [...TaiwanImportMirrorData.normalfilterList],
  tw_exports: [...TaiwanExportMirrorData.normalfilterList],
  sa_imports: [...SaudiArabiaImportMirrorData.normalfilterList],
  sa_exports: [...SaudiArabiaExportMirrorData.normalfilterList],
  ca_imports: [...CanadaImportMirrorData.normalfilterList],
  ca_exports: [...CanadaExportMirrorData.normalfilterList],
  de_imports: [...GermanyImportMirrorData.normalfilterList],
  de_exports: [...GermanyExportMirrorData.normalfilterList],
  hk_imports: [...HongKongImportMirrorData.normalfilterList],
  hk_exports: [...HongKongExportMirrorData.normalfilterList],
  jp_imports: [...JapanImportMirrorData.normalfilterList],
  jp_exports: [...JapanExportMirrorData.normalfilterList],
  kr_imports: [...SouthKoreaImportMirrorData.normalfilterList],
  kr_exports: [...SouthKoreaExportMirrorData.normalfilterList],
  usm_imports: [...USImportSearchMirrorData.normalfilterList],
  usm_exports: [...USExportSearchMirrorData.normalfilterList],
  mxm_imports: [...MexicoImportSearchMaritimeData.normalfilterList],
  mxm_exports: [...MexicoExportSearchMaritimeData.normalfilterList],
  global_imports: [...GlobalImportData.normalfilterList],
  bw_imports: [...BotswanaImportData.normalfilterList],
  bw_exports: [...BotswanaExportData.normalfilterList],
  gh_imports: [...GhanaImportData.normalfilterList],
  gh_exports: [...GhanaExportData.normalfilterList],
  ls_imports: [...LesothoImportData.normalfilterList],
  ls_exports: [...LesothoExportData.normalfilterList],
  pk_imports: [...PakistanImportData.normalfilterList],
  pk_exports: [...PakistanExportData.normalfilterList],
  ci_imports: [...IvoryCoastImportData.normalfilterList],
  ci_exports: [...IvoryCoastExportData.normalfilterList],
  rw_imports: [...RwandaImportData.normalfilterList],
  na_imports: [...NamibiaImportData.normalfilterList],
  na_exports: [...NamibiaExportData.normalfilterList],
  cm_imports: [...CameroonImportData.normalfilterList],
  bd_imports: [...BangladeshImportData.normalfilterList],
  bd_exports: [...BangladeshExportData.normalfilterList],
  ng_imports: [...NigeriaImportData.normalfilterList],
  ng_exports: [...NigeriaExportData.normalfilterList],
  kz_imports: [...KazakhstanImportData.normalfilterList],
  kz_exports: [...KazakhstanExportData.normalfilterList],
  uz_imports: [...UzbekistanImportData.normalfilterList],
  uz_exports: [...UzbekistanExportData.normalfilterList],
  lk_imports: [...SriLankaImportData.normalfilterList],
  lk_exports: [...SriLankaExportData.normalfilterList],
  py_imports: [...ParaguayImportData.normalfilterList],
  py_exports: [...ParaguayExportData.normalfilterList],
  cr_imports: [...CostaRicaImportData.normalfilterList],
  cr_exports: [...CostaRicaExportData.normalfilterList],
  et_imports: [...EthiopiaImportData.normalfilterList],
  et_exports: [...EthiopiaExportData.normalfilterList],
  ug_imports: [...UgandaImportData.normalfilterList],
  ug_exports: [...UgandaExportData.normalfilterList],
};

export const intelAPIEndpoints = {
  getDasboardAPI: getApiUrl("userDashboard"),
  getDownloadShipments: getApiUrl("getDownloadShipments"),
  deleteSavedSearchByName: getApiUrl("deleteSavedSearch"),
  updateEmailAlert: getApiUrl("updateEmailAlertStatus"),
  getDownloadAllContactInAddressBook: getApiUrl("CompanyContactDetails/downloadAddressbookOfUser"),
  createExcelFavouriteCompany: getApiUrl("createExcelFavouriteCompany"),
  profile: getApiUrl("getUserProfile"), // Deprecated - use profileComplete and profileIntel instead
  profileComplete: globalGetApiUrl("auth/getUserProfileComplete"),
  profileIntel: getApiUrl("getUserIntelDetails"),
  getCompanySlug: getApiUrl("companyProfiles/getSlug"),
  frequencyAPI: getApiUrl("countryAlertType"),
  sendcompanyProfileToSalesforce: getApiUrl("sendcompanyProfileToSalesforce"),
  sendContacttoSalesforce: getApiUrl("sendContactToSalesforce"),
  sendcompanyProfileToHubspot: getApiUrl("sendcompanyProfileToHubspot"),
  sendContacttoHubspot: getApiUrl("sendContactToHubspot"),
  sendcompanyProfileToZoho: getApiUrl("sendcompanyProfileToZoho"),
  sendContacttoZoho: getApiUrl("sendContactToZoho"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  saveFavouriteCompanies: getApiUrl("addFavouriteCompany"),
  usersAllFavouriteCompanyTags: getApiUrl("usersAllFavouriteCompanyTags"),
  errorLogAPI: getApiUrl("downloadLogs"),
  featureNudge: getApiUrl("featureNudge"),
  featureNudgeUpdate: getApiUrl("featureNudgeUpdate"),
  notifySales: getApiUrl("notifySales"),
  userRecentSearches: getApiUrl("user_recent_searches"),
  userTopSearches: getApiUrl("user_top_searches"),
};

export const countryCapsToSmall = {
  "united kingdom": "uk",
  "united states": "us",
};
